import React from 'react';

const icon = () => {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 14">
        <title>svg return</title>

        <path d="M6,4.94,7.63,3.21a2.05,2.05,0,0,0,.54-1.37A1.78,1.78,0,0,0,6.46,0,1.59,1.59,0,0,0,5.33.49l0,0,0,.06L0,7l5.25,6.44A1.65,1.65,0,0,0,6.46,14a1.78,1.78,0,0,0,1.71-1.84,1.92,1.92,0,0,0-.51-1.31L6,9.08H17.09A2,2,0,0,0,19,7a2,2,0,0,0-1.91-2.07Z"/>
        <path d="M26,7a2,2,0,1,0-2,2,2,2,0,0,0,2-2"/>
      </svg>
  )
}

export default icon



// WEBPACK FOOTER //
// ./src/shared/images/svg/return.js